import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MemberCard from '@coeldery/member-card';
import { apiGet } from '../../lib/api';
import { brand } from '../../brand';

interface CardData {
  member: {
    name: string;
    member_no: string | null;
    company: string | null;
    status: string;
    type_code: string;
    /** 會員相片（Cloudinary secure_url；`decisions/012`）——冇就 null */
    photo_url?: string | null;
  };
  membership: { start_at: string; end_at: string; paid: number } | null;
  type: { code: string; name_zh_hk: string; name_zh_cn: string; name_en: string } | null;
}

/** 我的卡（tab 3）—— 自己嘅數碼會員卡（讀 `/api/me/card`） */
export default function MyCardsPage() {
  const { t, i18n } = useTranslation();
  const [card, setCard] = useState<CardData | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    void apiGet<{ card: CardData | null }>('/api/me/card').then((r) => {
      if (r.ok && r.data) setCard(r.data.card);
      setLoaded(true);
    });
  }, []);

  const typeName = (c: CardData): string => {
    const ty = c.type;
    if (!ty) return c.member.type_code;
    if (i18n.language === 'en') return ty.name_en;
    if (i18n.language === 'zh-CN') return ty.name_zh_cn;
    return ty.name_zh_hk;
  };

  return (
    <div className="max-w-md mx-auto">
      <h2 className="text-lg font-bold mb-3">{t('tab.cards')}</h2>
      {loaded && !card ? <p style={{ color: 'var(--color-text-secondary)' }}>{t('card_no_link')}</p> : null}
      {card ? (
        <MemberCard
          brandLabel={t('app_name')}
          logoUrl={brand.logos.mark}
          photoUrl={card.member.photo_url ?? null}
          name={card.member.name}
          memberNo={card.member.member_no}
          typeLabel={typeName(card)}
          statusLabel={t(`status_${card.member.status}`)}
          company={card.member.company}
          expiresText={card.membership ? card.membership.end_at.slice(0, 10) : null}
          memberNoLabel={t('card_member_no')}
          expiresLabel={t('card_expires')}
        />
      ) : null}
    </div>
  );
}

